import React, {useEffect, useState} from 'react';
import "./App.css";
import Layout from "./components/Layout";
// import QLIHome from "./components/Home";
import {verifyUserAuthentication} from "./components/api";
import QLIAlert from "./components/Alert";


function App() {
  
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertVariant, setShowAlertVariant] = useState('success');
  const [showAlertMessage, setShowAlertMessage] = useState('');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const redirectToLogin = () => {
    localStorage.setItem('postLoginRedirect', window.location.pathname);
    window.location.href = "/auth/login";
  };
  
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    setLoading(true);
    verifyUserAuthentication()
      .then((res) => {
        if (res.status === 200) {
          setUserData(res.data);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setIsAuthenticated(false);
          // Do not redirect immediately; let user click "Login with Azure AD" button [when dual authentication is supported]
          // remove the below line and uncomment the QLIHome return block to enable this behavior
          redirectToLogin();
        } else {
          setShowAlertVariant('danger');
          setShowAlertMessage('Error verifying user authentication. Please try again later.');
          setShowAlert(true);
        }
      })
      .finally(() => {
        setLoading(false);
        const redirectPath = localStorage.getItem('postLoginRedirect');
        if (redirectPath) {
          localStorage.removeItem('postLoginRedirect');
          if (redirectPath !== window.location.pathname) {
            window.location.replace(redirectPath);
          }
        }
      });
  }, []);
  
  if (loading) {
    return <div className="loading-container">
      <div className="loading-spinner"/>
      <div>Loading...</div>
    </div>;
  }
  // uncomment the QLIHome return block to enable this behavior
  // if (!loading && !isAuthenticated) {
  //   return <QLIHome loginUser={() => redirectToLogin()}/>;
  // }
  
  return <>
    {showAlert && <QLIAlert variant={showAlertVariant} message={showAlertMessage}/>}
    {isAuthenticated && <Layout username={userData?.user?.name} user={userData?.user}/>}
  </>;
}

export default App;
